module.exports = __webpack_public_path__ + "img/applications-empty-state.0861e55d.svg";